import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b326c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "company_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "company_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "company_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "company_layout_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_badge" }, "職歴", -1))
const _hoisted_6 = { class: "entry_career_company_name" }
const _hoisted_7 = { class: "entry_career_company_businesstype" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職種", -1))
const _hoisted_9 = { class: "entry_career_company_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "在籍期間", -1))
const _hoisted_11 = {
  key: 0,
  class: "entry_career_company_item_content"
}
const _hoisted_12 = {
  key: 1,
  class: "entry_career_company_item_content"
}
const _hoisted_13 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_14 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "社員数", -1))
const _hoisted_16 = { class: "entry_career_company_item_content" }
const _hoisted_17 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "雇用形態", -1))
const _hoisted_19 = { class: "entry_career_company_item_content" }
const _hoisted_20 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_21 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "年収", -1))
const _hoisted_23 = { class: "entry_career_company_item_content" }
const _hoisted_24 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "月収", -1))
const _hoisted_26 = { class: "entry_career_company_item_content" }
const _hoisted_27 = { class: "entry_career_company_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職務内容", -1))
const _hoisted_29 = { class: "entry_career_company_item_content" }
const _hoisted_30 = { class: "entry_career_company_item_content_display_textarea" }
const _hoisted_31 = { class: "entry_career_company_button" }
const _hoisted_32 = { class: "company_button_register" }
const _hoisted_33 = { class: "company_button_modify" }

import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { ref, computed } from 'vue';
import { EditingWorkHistoryDetailInfo } from '@/types';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';
import { MasterEmpTypeBusicr } from '@/api/masterDataEndpoint';

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyConfirmView',
  setup(__props) {

const isLoading = ref(false);
const route = useRoute();
const router = useRouter();

const shownReadMore = ref(false);
const close = () => {
  shownReadMore.value = false;
};
const readMore = () => {
  shownReadMore.value = true;
};

const workHistoryDetailInfo: EditingWorkHistoryDetailInfo = store.getters['workHistory/editingWorkHistoryDetailInfo'];
const mstIndsctgFlat: { [key: number]: string } = store.getters['master/mstIndsctgFlat'];
const mstOcupClassFlat: { [key: number]: string } = store.getters['master/mstOcupClassFlat'];
const mstEmpTypeBusicr: MasterEmpTypeBusicr[] = store.getters['master/mstEmpTypeBusicr'];

const indsctgName =
  workHistoryDetailInfo.indsctgId === null || workHistoryDetailInfo.indsctgId === undefined
    ? ''
    : mstIndsctgFlat[workHistoryDetailInfo.indsctgId] || '';
const busicrOcupctgName =
  (!workHistoryDetailInfo.busicrOcupctg1Id ? '' : mstOcupClassFlat[Number(workHistoryDetailInfo.busicrOcupctg1Id)]) +
  (!workHistoryDetailInfo.busicrOcupctg2Id ? '' : '/' + mstOcupClassFlat[Number(workHistoryDetailInfo.busicrOcupctg2Id)]) +
  (!workHistoryDetailInfo.busicrOcupctg3Id ? '' : '/' + mstOcupClassFlat[Number(workHistoryDetailInfo.busicrOcupctg3Id)]);
const getEmpTypeBusicrText = computed(() => {
  return mstEmpTypeBusicr.find((i) => i.code === workHistoryDetailInfo.emptypeId)?.name;
});

const transitionPreviousPage = () => {
  router.back();
  // router.push({ name: 'e35' });
};

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('workHistory/putWorkHistoryDetailInfo');
    store.dispatch('toasts/appendTimeToast', { label: '職歴を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e33', query: { ref: 'e' } });
    } else {
      router.push({ name: 'e33' });
    }
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["entry_career_company", { 'is-readmore-close': !shownReadMore.value }])
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(workHistoryDetailInfo).compname), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(indsctgName)), 1),
          _createElementVNode("div", { class: "entry_career_company_item" }, [
            _hoisted_8,
            _createElementVNode("div", { class: "entry_career_company_item_content" }, _toDisplayString(busicrOcupctgName))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (!!_unref(workHistoryDetailInfo).wkperiodeDateyr && !!_unref(workHistoryDetailInfo).wkperiodeDatemon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(workHistoryDetailInfo).wkperiodsDateyr) + "." + _toDisplayString(_unref(workHistoryDetailInfo).wkperiodsDatemon) + "〜" + _toDisplayString(_unref(workHistoryDetailInfo).wkperiodeDateyr) + "." + _toDisplayString(_unref(workHistoryDetailInfo).wkperiodeDatemon), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, " 在籍中 " + _toDisplayString(_unref(workHistoryDetailInfo).wkperiodsDateyr) + "." + _toDisplayString(_unref(workHistoryDetailInfo).wkperiodsDatemon) + "〜現在 ", 1))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(workHistoryDetailInfo).employeeNum ? _unref(workHistoryDetailInfo).employeeNum : '-') + "人 ", 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(getEmpTypeBusicrText)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(workHistoryDetailInfo).annualincm ? _unref(workHistoryDetailInfo).annualincm : '-') + "万円 ", 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(workHistoryDetailInfo).salary ? _unref(workHistoryDetailInfo).salary : '-') + "万円 ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("pre", _hoisted_30, _toDisplayString(_unref(workHistoryDetailInfo).wkcontents), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            (shownReadMore.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button_readmore is-close",
                  onClick: close
                }, "閉じる"))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button_readmore",
                  onClick: readMore
                }, "もっと見る"))
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode("この内容で決定する")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("修正する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})